module.exports = __webpack_public_path__ + "img/dryer.dbd8052b.png";